module.exports = __webpack_public_path__ + "img/34200.8b50956f.jpg";